// extracted by mini-css-extract-plugin
export var locationCard = "_hn-0";